'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { getPropsFromItems } from '../../helpers/getNavigationProps';
import styles from './Footer.module.scss';
import { SecondaryNavigationCTA } from './SecondaryNavigationCTA';
const openUsercentricsSecondLayer = (event)=>{
    event.preventDefault();
    event.stopPropagation();
    window.__ucCmp?.showSecondLayer();
};
const attachUsercentricsClickHandler = (item)=>({
        ...item,
        ...item.href === '#uc-central-modal-show' ? {
            onClick: openUsercentricsSecondLayer
        } : {},
        items: item.items?.map(attachUsercentricsClickHandler)
    });
export const SecondaryNavigation = ({ footerSecondaryNavigation })=>{
    const secondaryNavigation = getPropsFromItems(footerSecondaryNavigation ?? []).map(attachUsercentricsClickHandler);
    if (!secondaryNavigation) {
        return null;
    }
    return /*#__PURE__*/ _jsx("menu", {
        className: classNames(styles.menu, [
            styles['menu-secondary']
        ]),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles['secondary-nav'],
            children: secondaryNavigation[0]?.items?.map(({ href, onClick, text, tracking })=>/*#__PURE__*/ _jsx(SecondaryNavigationCTA, {
                    href: href,
                    onClick: onClick,
                    text: text,
                    tracking: tracking
                }, text))
        })
    });
};

//# sourceMappingURL=SecondaryNavigation.js.map